module.exports = __webpack_public_path__ + "img/ver-mais.c84e2124.svg";